const container=[{initial:"empty record"}]
const programRe=(state=container,action)=>{

// console.log("payload 2",action.payload)
  switch(action.type){

 case'PROGRAM':
 return {record:action.payload}

 default:
   return state;

  }
}


export default programRe;